export default "__VITE_ASSET__w48viJyY__"